<template>
  <div class="cf-menu-list-target">
    <transition name="fade-down-only-in">
      <div
        v-if="!selectedCategory"
        class="cf-grid cf-grid--3-to-2-dyanimic-grid cf-grid--gap-16 cf-tablet-padding-16"
      >
        <cf-menu-list-category-card
          v-for="(category, categoryIndex) in categories"
          :id="`category-${category.categoryId}`"
          :key="category.categoryId"
          :category="category"
          :category-index="categoryIndex"
          @category-card-click-handler="categoryCardClickHandler"
        />
      </div>
    </transition>

    <transition name="fade-up-only-in">
      <div
        v-if="selectedCategory"
        class="cf-menu-list cf-menu-list--default"
      >
        <button
          type="button"
          tabindex="-1"
          class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-8 cf-cursor-pointer"
          @click="allCategoriesClickHandler"
        >
          <span class="cf-icon cf-icon--small far fa-arrow-left" />

          <h3 class="cf-title cf-title--3">
            All Categories
          </h3>
        </button>

        <cf-menu-list-category
          :category="selectedCategory"
          :category-index="selectedCategoryIndex"
          :open-category-ids="openCategoryIds"
          :is-auto-open-category="true"
          :is-read-only="isReadOnly"
          @open-menu-list-category="handleOpenCategoryClick"
        />
      </div>
    </transition>
  </div>
</template>


<script>
  import { generateCategoryHash, setBrowserHash } from '@/helpers/menu-hash-helper';

  import CfMenuListCategoryCard from './cf-menu-list-category-card/index.vue';
  import CfMenuListCategory from '../cf-menu-list-category/index.vue';


  export default {
    name: 'CfMenuListCategoryCards',

    components: {
      CfMenuListCategoryCard,
      CfMenuListCategory
    },

    props: {
      categories: {
        type: Array,
        required: true
      },

      openCategoryIds: {
        type: Array,
        required: true
      },

      isReadOnly: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        selectedCategory: null,
        selectedCategoryIndex: null
      };
    },

    methods: {
      categoryCardClickHandler({ category, categoryIndex }) {
        this.selectedCategory = category;
        this.selectedCategoryIndex = categoryIndex;

        if (category && category.displayName) {
          const categoryHash = generateCategoryHash(category.displayName);
          setBrowserHash(categoryHash);
        }
      },

      allCategoriesClickHandler() {
        this.selectedCategory = null;
        this.selectedCategoryIndex = null;
      },

      handleOpenCategoryClick(category) {
        if (category && category.displayName) {
          const categoryHash = generateCategoryHash(category.displayName);
          setBrowserHash(categoryHash);
        }

        this.$emit('open-menu-list-category', category);
      }
    }
  };
</script>
